module.exports = __webpack_public_path__ + "assets/img/36_328.d61d72dd.jpg";